import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { ExpandingFAQ, FrequentlyAskedQuestionsContainer } from './FrequentlyAskedQuestions';
import { useFaqToggleHandler, useLinkClickHandler } from './FrequentlyAskedQuestionsUtils';
import { getAcademyUrlPublic, getAppMarketplaceUrl, getCMSUrlPublic, getCommunityUrlPublic, getDevelopersAndApiDocsBaseUrl, getDevelopersApiDocsUrl, getDevelopersQuickStartGuideUrl, getKBEmbedCTAUrlPublic, getKBImportToolUrlPublic, getKBMembershipsUrlPublic, getKBShareFormsUrlPublic, getKBTrackingCodeUrlPublic, getKnowledgeBaseUrlPublic, getLanguagesUrlPublic, getMembershipsExamplesUrl, getMicrositesExamplesUrl, getNonProfitsUrlPublic, getSecurityAndComplianceUrl, getSolutionsMarketplaceUrl, getStartupsUrlPublic, getTemplatesMarketplaceUrl, getWebsiteMigrationUrlPublic } from './FrequentlyAskedQuestionsPublicPageUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const communityHref = getCommunityUrlPublic();
const langHref = getLanguagesUrlPublic();
const academyHref = getAcademyUrlPublic();
const kbHref = getKnowledgeBaseUrlPublic();
const cmsHref = getCMSUrlPublic();
const startupsHref = getStartupsUrlPublic('pricing-contentpage');
const nonprofitsHref = getNonProfitsUrlPublic('pricing-contentpage');
const shareFormsHref = getKBShareFormsUrlPublic();
const embedCTAHref = getKBEmbedCTAUrlPublic();
const trackingCodeHref = getKBTrackingCodeUrlPublic();
const micrositesExamplesHref = getMicrositesExamplesUrl();
const membershipsHref = getKBMembershipsUrlPublic();
const membershipsExamplesHref = getMembershipsExamplesUrl();
const quickStartHref = getDevelopersQuickStartGuideUrl();
const apiHref = getDevelopersAndApiDocsBaseUrl();
const hostingAndSecurityHref = getSecurityAndComplianceUrl();
const templatesHref = getTemplatesMarketplaceUrl();
const importToolHref = getKBImportToolUrlPublic();
const apiDocsHref = getDevelopersApiDocsUrl();
const solutionsPartnerHref = getSolutionsMarketplaceUrl();
const websiteMigrationHref = getWebsiteMigrationUrlPublic();
const appMarketPlaceHref = getAppMarketplaceUrl();
export const ContentHubFaqs = ({
  onLinkClick,
  onFaqInteraction
} = {}) => {
  const handleFaqToggle = useFaqToggleHandler(onFaqInteraction);
  const handleLinkClick = useLinkClickHandler(onLinkClick);
  return /*#__PURE__*/_jsxs(FrequentlyAskedQuestionsContainer, {
    children: [/*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.whatIsContentHub.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.whatIsContentHub.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          learnMoreLink: /*#__PURE__*/_jsx(Link, {
            href: cmsHref,
            external: true,
            onClick: () => handleLinkClick('content.whatIsContentHub', cmsHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.whatIsContentHub.learnMore"
            })
          })
        }
      }),
      onExpandedChange: () => handleFaqToggle('content.whatIsContentHub', 'pricing-page-components.frequentlyAskedQuestions.content.whatIsContentHub.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.existingWebsite.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.existingWebsite.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          list: /*#__PURE__*/_jsxs("ul", {
            children: [/*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricing-page-components.frequentlyAskedQuestions.content.existingWebsite.listItem1"
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricing-page-components.frequentlyAskedQuestions.content.existingWebsite.listItem2"
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricing-page-components.frequentlyAskedQuestions.content.existingWebsite.listItem3"
              })
            })]
          }),
          appMarketPlaceLink: /*#__PURE__*/_jsx(Link, {
            href: appMarketPlaceHref,
            onClick: () => handleLinkClick('content.existingWebsite.appMarketplace', appMarketPlaceHref),
            external: true,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.existingWebsite.appMarketplace"
            })
          }),
          formsLink: /*#__PURE__*/_jsx(Link, {
            href: shareFormsHref,
            onClick: () => handleLinkClick('content.existingWebsite.forms', shareFormsHref),
            external: true,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.existingWebsite.forms"
            })
          }),
          ctasLink: /*#__PURE__*/_jsx(Link, {
            href: embedCTAHref,
            onClick: () => handleLinkClick('content.existingWebsite.ctas', embedCTAHref),
            external: true,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.existingWebsite.ctas"
            })
          }),
          trackingLink: /*#__PURE__*/_jsx(Link, {
            href: trackingCodeHref,
            external: true,
            onClick: () => handleLinkClick('content.existingWebsite.tracking', trackingCodeHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.existingWebsite.tracking"
            })
          })
        }
      }),
      onExpandedChange: () => handleFaqToggle('content.existingWebsite', 'pricing-page-components.frequentlyAskedQuestions.content.existingWebsite.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.micrositeCustomPortal.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.micrositeCustomPortal.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          websiteBuilderLink: /*#__PURE__*/_jsx(Link, {
            href: cmsHref,
            external: true,
            onClick: () => handleLinkClick('content.micrositeCustomPortal.websiteBuilder', cmsHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.micrositeCustomPortal.websiteBuilder"
            })
          }),
          micrositesExamplesLink: /*#__PURE__*/_jsx(Link, {
            href: micrositesExamplesHref,
            external: true,
            onClick: () => handleLinkClick('content.micrositeCustomPortal.micrositesExamples', micrositesExamplesHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.micrositeCustomPortal.here"
            })
          }),
          membershipsLink: /*#__PURE__*/_jsx(Link, {
            href: membershipsHref,
            external: true,
            onClick: () => handleLinkClick('content.micrositeCustomPortal.memberships', membershipsHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.micrositeCustomPortal.memberships"
            })
          }),
          membershipsExamplesLink: /*#__PURE__*/_jsx(Link, {
            href: membershipsExamplesHref,
            external: true,
            onClick: () => handleLinkClick('content.micrositeCustomPortal.membershipsExamples', membershipsExamplesHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.micrositeCustomPortal.here"
            })
          })
        }
      }),
      onExpandedChange: () => handleFaqToggle('content.micrositeCustomPortal', 'pricing-page-components.frequentlyAskedQuestions.content.micrositeCustomPortal.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.trainDevelopersAndIT.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.trainDevelopersAndIT.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          list: /*#__PURE__*/_jsxs("ul", {
            children: [/*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                href: quickStartHref,
                onClick: () => handleLinkClick('content.trainDevelopersAndIT.quickStart', quickStartHref),
                external: true,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "pricing-page-components.frequentlyAskedQuestions.content.trainDevelopersAndIT.listItem1"
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                href: apiHref,
                onClick: () => handleLinkClick('content.trainDevelopersAndIT.api', apiHref),
                external: true,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "pricing-page-components.frequentlyAskedQuestions.content.trainDevelopersAndIT.listItem2"
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                href: hostingAndSecurityHref,
                onClick: () => handleLinkClick('content.trainDevelopersAndIT.hostingSecurity', hostingAndSecurityHref),
                external: true,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "pricing-page-components.frequentlyAskedQuestions.content.trainDevelopersAndIT.listItem3"
                })
              })
            })]
          })
        }
      }),
      onExpandedChange: () => handleFaqToggle('content.trainDevelopersAndIT', 'pricing-page-components.frequentlyAskedQuestions.content.trainDevelopersAndIT.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          list: /*#__PURE__*/_jsxs("ul", {
            children: [/*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.listItem1",
                options: {
                  templatesLink: /*#__PURE__*/_jsx(Link, {
                    href: templatesHref,
                    external: true,
                    onClick: () => handleLinkClick('content.migrateExistingWebsite.templates', templatesHref),
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.templateMarketplace"
                    })
                  }),
                  importToolLink: /*#__PURE__*/_jsx(Link, {
                    href: importToolHref,
                    external: true,
                    onClick: () => handleLinkClick('content.migrateExistingWebsite.importTool', importToolHref),
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.importTools"
                    })
                  }),
                  quickStartLink: /*#__PURE__*/_jsx(Link, {
                    href: quickStartHref,
                    external: true,
                    onClick: () => handleLinkClick('content.migrateExistingWebsite.quickStart1', quickStartHref),
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.developerQuickStart"
                    })
                  })
                }
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.listItem2",
                options: {
                  quickStartLink: /*#__PURE__*/_jsx(Link, {
                    href: quickStartHref,
                    external: true,
                    onClick: () => handleLinkClick('content.migrateExistingWebsite.quickStart2', quickStartHref),
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.developerQuickStart"
                    })
                  }),
                  apiDocsLink: /*#__PURE__*/_jsx(Link, {
                    href: apiDocsHref,
                    external: true,
                    onClick: () => handleLinkClick('content.migrateExistingWebsite.apiDocs', apiDocsHref),
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.apis"
                    })
                  })
                }
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.listItem3",
                options: {
                  solutionsPartnerLink: /*#__PURE__*/_jsx(Link, {
                    href: solutionsPartnerHref,
                    external: true,
                    onClick: () => handleLinkClick('content.migrateExistingWebsite.solutionsPartner', solutionsPartnerHref),
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.solutionsPartner"
                    })
                  })
                }
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.listItem4",
                options: {
                  websiteMigrationLink: /*#__PURE__*/_jsx(Link, {
                    href: websiteMigrationHref,
                    external: true,
                    onClick: () => handleLinkClick('content.migrateExistingWebsite.websiteMigration', websiteMigrationHref),
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.websiteMigrationService"
                    })
                  })
                }
              })
            })]
          })
        }
      }),
      onExpandedChange: () => handleFaqToggle('content.migrateExistingWebsite', 'pricing-page-components.frequentlyAskedQuestions.content.migrateExistingWebsite.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.whatSupport.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.whatSupport.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          langLink: /*#__PURE__*/_jsx(Link, {
            href: langHref,
            external: true,
            onClick: () => handleLinkClick('content.whatSupport.languageOfferings', langHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.whatSupport.languageOfferings"
            })
          }),
          communityLink: /*#__PURE__*/_jsx(Link, {
            href: communityHref,
            external: true,
            onClick: () => handleLinkClick('content.whatSupport.hubSpotCommunity', communityHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.whatSupport.hubSpotCommunity"
            })
          }),
          academyLink: /*#__PURE__*/_jsx(Link, {
            href: academyHref,
            external: true,
            onClick: () => handleLinkClick('content.whatSupport.hubSpotAcademy', academyHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.whatSupport.hubSpotAcademy"
            })
          }),
          kbLink: /*#__PURE__*/_jsx(Link, {
            href: kbHref,
            external: true,
            onClick: () => handleLinkClick('content.whatSupport.knowledgeBase', kbHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.whatSupport.knowledgeBase"
            })
          })
        }
      }),
      onExpandedChange: () => handleFaqToggle('content.whatSupport', 'pricing-page-components.frequentlyAskedQuestions.content.whatSupport.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.whatDiscounts.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.whatDiscounts.answer",
        options: {
          startupsLink: /*#__PURE__*/_jsx(Link, {
            href: startupsHref,
            external: true,
            onClick: () => handleLinkClick('content.whatDiscounts.hubSpotStartups', startupsHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.whatDiscounts.hubSpotStartupsProgram"
            })
          }),
          nonprofitsLink: /*#__PURE__*/_jsx(Link, {
            href: nonprofitsHref,
            external: true,
            onClick: () => handleLinkClick('content.whatDiscounts.hubSpotNonprofits', nonprofitsHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.content.whatDiscounts.hubSpotNonprofits"
            })
          })
        }
      }),
      onExpandedChange: () => handleFaqToggle('content.whatDiscounts', 'pricing-page-components.frequentlyAskedQuestions.content.whatDiscounts.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.whenEligibleForNewPricing.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.content.whenEligibleForNewPricing.answer"
      }),
      onExpandedChange: () => handleFaqToggle('content.whenEligibleForNewPricing', 'pricing-page-components.frequentlyAskedQuestions.content.whenEligibleForNewPricing.question')
    })]
  });
};